<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>

      </template>
    </v-toolbar>

    <v-container fluid>


    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({

  }),
  mounted() {
    // this.loadData()
    // 1Be157gtvcumfJhJ3XXnrlIwwi1A1

    // 1sQygvoC5tOdI16W1FjIvQdwZKfyUPFnr
  },
  methods: {
    loadData() {
      this.axios.get('api/google-accounts/drive')
          .then(({data}) => {
            console.log(data)
          })
    }
  }
}
</script>